module.exports = __webpack_public_path__ + "img/最新上传.aca354a3.png";